import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://gammalens-api.onrender.com'
  : `http://${window.location.hostname}:8001`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Attach auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gl_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const getGEXAnalysis = async (ticker) => {
  const response = await api.get(`/api/gex/${ticker}`);
  return response.data;
};

export const getGEXLevels = async (ticker) => {
  const response = await api.get(`/api/gex/${ticker}/levels`);
  return response.data;
};

export const getInterpretation = async (ticker) => {
  const response = await api.get(`/api/gex/${ticker}/interpret`);
  return response.data;
};

export const getMarketBrief = async () => {
  const response = await api.get('/api/market-brief');
  return response.data;
};

export const getTickers = async () => {
  const response = await api.get('/api/tickers');
  return response.data;
};

export const checkHealth = async () => {
  const response = await api.get('/api/health');
  return response.data;
};

export const getAccuracyScorecard = async (days = 30) => {
  const response = await api.get(`/api/accuracy/scorecard?days=${days}`);
  return response.data;
};

export const getAccuracyToday = async () => {
  const response = await api.get('/api/accuracy/today');
  return response.data;
};

export const getTickerAccuracy = async (ticker, days = 30) => {
  const response = await api.get(`/api/accuracy/history/${ticker}?days=${days}`);
  return response.data;
};
